import { ConfigFlags } from 'services/clip.service';
import { ClipsMap } from '../editor/_mediator/editor.slice';
import { Option } from 'components/UI/select/select';

export const getSbOrderClips = (
  clipsMap: ClipsMap | null
): { firstClipOrder: ClipId | undefined; lastClipOrder: ClipId | undefined } => {
  if (!clipsMap) {
    return { firstClipOrder: undefined, lastClipOrder: undefined };
  }
  const firstClipOrder = Object.values(clipsMap)?.filter((i) => i?.config.flags.includes(ConfigFlags.orderFirst))[0]
    ?.clipId;
  const lastClipOrder = Object.values(clipsMap)?.filter((i) => i?.config.flags.includes(ConfigFlags.orderLast))[0]
    ?.clipId;
  return { firstClipOrder, lastClipOrder };
};

export function enumToOptions<T>(enumObj: T): Option[] {
  return Object.keys(enumObj as object)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      label: key
        .replace(/([A-Z])/g, ' $1')
        .replace('is', '')
        .trim(),
      value: enumObj[key as keyof T] as number,
    }));
}
